import { create } from 'zustand';

export type ToastVariant = 'default' | 'success' | 'warning' | 'destructive';

export interface Toast {
  id: number;
  title?: string;
  description?: string;
  variant?: ToastVariant;
}

interface ToastStore {
  toasts: Toast[];
  push: (t: Omit<Toast, 'id'>) => number;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastStore>((set, get) => ({
  toasts: [],
  push: (t) => {
    const id = nextId++;
    set({ toasts: [...get().toasts, { ...t, id }] });
    setTimeout(() => get().dismiss(id), 3500);
    return id;
  },
  dismiss: (id) => set({ toasts: get().toasts.filter((x) => x.id !== id) }),
}));

/** Convenience hook with sugar functions (matches shadcn `useToast` shape). */
export function useToast() {
  const push = useToastStore((s) => s.push);
  return {
    toast: (t: Omit<Toast, 'id'>) => push(t),
    success: (title: string, description?: string) => push({ title, description, variant: 'success' }),
    error: (title: string, description?: string) => push({ title, description, variant: 'destructive' }),
    info: (title: string, description?: string) => push({ title, description }),
  };
}
